const COLOURS = {
    lightRed: "#E7625F",
    lightYellow: "#FFED86"
}

export default COLOURS;